import { connect } from 'react-redux';
import { getCommentReactions } from '../../redux/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    reactions: getCommentReactions(state, ownProps.comment),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=ReactionsDisplay.container.js.map